import React from "react";


 
export default function IncidentPriorityLegend({ title, items = [], position = "bottom-left" }) {
  const posStyle =
    position === "bottom-right"
      ? { bottom: 14, right: 14 }
      : position === "top-left"
      ? { top: 14, left: 14 }
      : position === "top-right"
      ? { top: 14, right: 14 }
      : { bottom: 14, left: 14 }; 

  return (
    <div
      style={{
        position: "absolute",
        ...posStyle,
        background: "#ffffff",
        borderRadius: 8,
        padding: "8px 10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        fontSize: 12,
        lineHeight: 1.35,
        zIndex: 10,
        maxWidth: 220,
        userSelect: "none",
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 6 }}>{title}</div>

      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {items.map((it) => (
          <div
            key={it.key}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              whiteSpace: "nowrap",
            }}
          >
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: it.color,
                border: "2px solid #fff",
                boxShadow: "0 0 0 1px rgba(0,0,0,0.10)",
                flex: "0 0 auto",
              }}
            />
            <span style={{ color: "#111827" }}>{it.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
